import { Link } from 'react-router-dom';
import { getImageUrl } from '../utils/api';

interface ComingSoonPageProps {
    message?: string;
    image?: string;
    mobileImage?: string;
}

const ComingSoonPage: React.FC<ComingSoonPageProps> = ({ message, image, mobileImage }) => {
    const desktopUrl = getImageUrl(image);
    const mobileUrl = image && mobileImage ? getImageUrl(mobileImage) : desktopUrl;

    return (
        <div className="h-screen w-screen bg-white flex items-center justify-center overflow-hidden relative m-0 p-0">
            {/* Full Screen Banner Image - Zero Margins, Zero Padding */}
            <div className="absolute inset-0 z-0 h-full w-full flex items-center justify-center bg-white">
                {desktopUrl ? (
                    <picture className="w-full h-full flex items-center justify-center">
                        {mobileUrl && (
                            <source
                                media="(max-width: 768px)"
                                srcSet={mobileUrl}
                            />
                        )}
                        <img
                            src={desktopUrl}
                            alt="Maintenance"
                            className="w-full h-full object-contain m-0 p-0 block"
                        />
                    </picture>
                ) : (
                    <div className="w-full h-full bg-slate-900"></div>
                )}
            </div>


            {/* 'Post Property' Button - Optimized Container for Perfect Centering & Animation */}
            <div className="absolute top-6 left-1/2 -translate-x-1/2 md:top-12 md:right-12 md:left-auto md:translate-x-0 z-50">
                <Link
                    to="/login"
                    className="relative animate-shimmer-btn animate-float-desktop inline-flex items-center gap-3 px-10 py-3.5 text-white text-[12px] md:text-[13px] font-black uppercase tracking-[0.25em] rounded-2xl transition-all shadow-[0_20px_50px_-15px_rgba(0,43,91,0.6)] hover:shadow-[0_25px_60px_-15px_rgba(0,43,91,0.8)] active:scale-[0.95] group border border-[#002B5B] hover:border-[#003d82] whitespace-nowrap"
                >
                    <i className="fa-solid fa-circle-plus text-xl group-hover:rotate-180 transition-transform duration-500"></i>
                    <span>Post Property</span>

                    {/* FREE Badge */}
                    <div className="absolute -top-3 -right-2 bg-[#ffbb00] text-[#05144b] text-[9px] font-black px-2 py-0.5 rounded leading-tight shadow-lg border border-white/20">
                        FREE
                    </div>
                </Link>
            </div>

            {/* Subtle Minimalist Footer */}
            <div className="absolute bottom-6 left-0 right-0 px-8 text-center z-10 pointer-events-none">
                <p className="text-black/20 text-[7px] md:text-[9px] font-black uppercase tracking-[0.6em] italic opacity-50">
                    &copy; 2026 My Property Guru &bull; Key Of Your Need
                </p>
            </div>
        </div>
    );
};

export default ComingSoonPage;
